import { Fragment } from 'react/jsx-runtime'
import RecipeLink from './RecipeLink'
import type { recipeLink } from '../../../../utils/recipeUtils'
import NewRecipeLink from './NewRecipeLink'

interface RecipeLinkListProps {
  links: recipeLink[]
  setLinks: React.Dispatch<React.SetStateAction<recipeLink[]>>
}

function RecipeLinkList({ links, setLinks }: RecipeLinkListProps) {
  const newLink = () => {
    const newLinks = [...links]
    const newLink: recipeLink = {
      id: 0,
      url: '',
      new: true,
    }
    newLinks.push(newLink)
    setLinks(newLinks)
  }

  const setLink = (index: number, newLink: recipeLink) => {
    const newLinks = [...links]
    newLinks[index] = newLink
    setLinks(newLinks)
  }

  const generateLinks = () => {
    return links.reduce((current, link, index) => {
      if (link.deleted) return current
      current.push(
        <RecipeLink key={link.id} index={index} link={link} setLink={setLink} />
      )
      return current
    }, [] as React.ReactNode[])
  }

  return (
    <div className="recipe-list-container">
      {
        <Fragment>
          {generateLinks()}
          <NewRecipeLink newLink={newLink} />
        </Fragment>
      }
    </div>
  )
}

export default RecipeLinkList
